import Step from './step';
import {createElement} from 'methods/utils';
import EmailRegisterStep from './email-register-step';
import NotificationStep from './notification-step';
import FormErrorsMixin from '../form-errors-mixin';

function EmailForgotStep(modal, options = {}) {
    const className = 'EmailForgotStep';
    const $element = createElement(
        `<div class="${className}">
            <div class="${className}__wrapper">
                <form action="/users_v2/forgot/" method="POST">
                    <div class="${className}__description">
                        Напишите  E-mail, указанный при регистрации. Туда будет отправлена инструкция по восстановлению
                    </div>
                    <div class="${className}__input-block">
                        <label class="${className}__input-label">E-mail</label>
                        <div class="${className}__input-group">
                            <input class="${className}__input" type="email" name="email">
                        </div>
                    </div>
                    <button class="${className}__submit js-submit">Отправить</button>
                </form>
            </div>
        </div>`
    );

    Step.call(this, modal, $element, options);
    FormErrorsMixin.call(this);

    this.className = className;

    this.$form = this.$element.querySelector('form');
    this.$form.addEventListener('submit', e => {
        e.preventDefault();
        this.submit();
    });
    this.$submit = this.$element.querySelector('.js-submit');
}

EmailForgotStep.prototype = Object.create(Step.prototype);
Object.assign(EmailForgotStep.prototype, FormErrorsMixin.prototype);
Object.defineProperty(EmailForgotStep.prototype, 'constructor', {
    value: EmailForgotStep,
    enumerable: false,
    writable: true,
});

EmailForgotStep.prototype.show = function() {
    this.modal.setTitle('Восстановление пароля');

    const $footer = createElement(
        `<div class="${this.className}__auth">
            <a href="javascript:void(0);" class="js-login">Войти</a>
            <a href="javascript:void(0);" class="js-register">Зарегистрироваться</a>
        </div>`
    );

    const $login = $footer.querySelector('.js-login');
    $login.addEventListener('click', e => {
        this.modal.prevStep();
    });

    const $register = $footer.querySelector('.js-register');
    $register.addEventListener('click', e => {
        // предыдущий шаг не должен вести на восстановление пароля
        const nextStep = new EmailRegisterStep(this.modal);
        nextStep.prevStep = this.prevStep;
        this.showStep(nextStep);
    });

    this.modal.setFooterContent($footer);
}

EmailForgotStep.prototype.submit = function() {
    const formData = new FormData(this.$form);

    this.$submit.classList.add('is-loading');
    this.resetFieldsErrors();

    return fetch(this.$form.action, {
        method: this.$form.method,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        if (r.status != 'ok') {
            this.showFieldsErrors(r.fields);
            return;
        }

        this.showStep(
            new NotificationStep(this.modal, {
                title: 'Письмо отправлено',
                description: `На почту ${this.$form.elements.email.value} была отправлена ссылка для смены пароля`,
            })
        );
    }).finally(() => {
        this.$submit.classList.remove('is-loading');
    });
}

export default EmailForgotStep;
